import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackIsSoldFurnishedLabelShow, trackShowRosreestrCheckedLabel } from './tracking';
import { LabelsList } from '../../../components/LabelsList';
import { useOfferContext } from '../../../context';
import { getIsDailyRent } from '../../../utils/computedProps/price/rent/getIsDailyRent';
import { selectEtazhiBlackFridayOfferLabelData } from 'shared/selectors/etazhiBlackFriday';

export function LabelsListContainer() {
  const { labels, jsonQuery, offer, position, isRosreestrCheckedLabelAvailable, isSoldFurnishedLabelAvailable } =
    useOfferContext();
  const isHotel = offer?.dailyrent?.hotelData?.isHotel;
  const isDailyRent = getIsDailyRent(offer.category);

  /**
   * Код появился к проекту "Чёрная пятница" для компании "Этажи".
   * @todo: удалить в задаче CD-250843
   */
  const etazhiBlackFridayLabel = useSelector(
    selectEtazhiBlackFridayOfferLabelData(offer.id, offer.bargainTerms.priceRur),
  );

  const labelsToShow = etazhiBlackFridayLabel ? [etazhiBlackFridayLabel, ...labels] : [...labels];

  const onShow = React.useCallback(() => {
    if (isRosreestrCheckedLabelAvailable) {
      trackShowRosreestrCheckedLabel(jsonQuery, { offerId: offer.id, position });
    }

    if (isSoldFurnishedLabelAvailable) {
      trackIsSoldFurnishedLabelShow(jsonQuery, { offerId: offer.id, position });
    }
  }, [isRosreestrCheckedLabelAvailable, isSoldFurnishedLabelAvailable, jsonQuery, offer.id, position]);

  if (!labelsToShow.length || isHotel || offer.isBookedFromDeveloper) {
    return null;
  }

  return <LabelsList labels={labelsToShow} onShow={onShow} isDailyRent={isDailyRent} />;
}
